<div class="d-flex flex-column align-items-center gap-3">
    <div class="title">{{ 'inactiveUser.title' | translate }}</div>
    <div class="description" *ngIf="!isSubtenant">
        {{ 'inactiveUser.noAccess' | translate }}
    </div>
    <div class="description" *ngIf="!isSubtenant && isValidEmailAccount">
        {{ 'inactiveUser.requestAccessToEmail' | translate: { email: emailAccount } }}
    </div>
    <div class="description" *ngIf="!isSubtenant && !isValidEmailAccount">
        {{ 'inactiveUser.emailIsNotVerified' | translate }}
    </div>
    <div class="description" *ngIf="isSubtenant">
        <span [innerHTML]="'inactiveUser.description' | translate: { partnerName: partnerName }"></span>
        <span class="link"> {{ phoneNumber }} </span>
        {{ 'inactiveUser.or' | translate }}
        <span class="link"> {{ email }} </span>
    </div>

    <button class="btn btn-outline-secondary gap-3 mt-2 mb-5" (click)="logout()">
        <i class="app-icon icon icon-log-out icon-lg"></i>
        <span class="text-main">Logout</span>
    </button>

    <no-records-placeholder></no-records-placeholder>
</div>